import { environmentConfig } from './environment.config'

const IS_DEV = process.env.NODE_ENV === environmentConfig.development

export const apiConfig = {
  prefix: IS_DEV ? 'https://api.plannenbank.nl' : 'https://api.plannenbank.nl',
}
